<div class="message-chart__header">
  <p *ngIf="chart.title" class="message-chart__title">{{ chart.title }}</p>
  <button
    type="button"
    class="message-chart__download"
    sgtTooltip="Salvar como imagem"
    (click)="onDownload()"
  >
    <i class="fas fa-download"></i>
  </button>
</div>
<div #chartEl class="message-chart__canvas"></div>
